<template>
  <div class="Sign">
    <el-dialog :visible.sync="dialogVisible" title="用户注册">
      <div class="left-img"></div>
      <div class="sign-menu">
        <el-form :model="details" :rules="rules" ref="details">
          <el-form-item :required="true" prop="userName">
            <el-input placeholder="请输入电话号码" v-model="details.userName">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-row>
              <el-col :span="16">
                <el-input placeholder="请输入图形码" v-model="details.imageVerification">
                </el-input>
              </el-col>
              <el-col :span="6" class="image" style="height:2.604rem;border: solid 1px #ddd;margin-left: 14px;border-radius: 6px;">
                <img :src="imgcode" @click="changeimgcode" alt="" class="imageVerification"/>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-row>
              <el-col :span="16">
                <el-input placeholder="请输入手机验证码" v-model="details.telCode">
                </el-input>
              </el-col>
              <el-col :span="6">
                <el-button @click="getcode(details)" class="verify" v-show="show">获取验证码</el-button>
                <el-button class="count verify" v-show="!show">{{ times }} s
                </el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <!-- <el-form-item prop="password">
            <el-input v-model="details.nickname" placeholder="请输入昵称">
            </el-input>
          </el-form-item> -->
          <el-form-item prop="password">
            <el-input placeholder="请设置8位以上的数字和字母组合密码" type="password" v-model="details.password">
            </el-input>
          </el-form-item>
          <el-form-item prop="checkPass">
            <el-input placeholder="请再次输入新密码" type="password" v-model="details.checkPass">
            </el-input>
          </el-form-item>
        </el-form>
        <el-button @click="signbtn(details)" class="sign">保存</el-button>
        <div class="login-text">已有账号，<span @click="loginBtn">马上登录</span></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {register, telVerification} from "@/utils/router/login.api";

  export default {
    name: "sign",
    data() {
      var validateMobilePhone = (rule, value, callback) => {
        if (value === "") {
          callback(new Error("手机号不可为空"));
        } else {
          if (value !== "") {
            var reg = /^(0|86|17951)?(13[0-9]|14[57]|15[0-9]|17[0-9]|18[0-9]|19[189])[0-9]{8}$/;
            if (!reg.test(value)) {
              callback(new Error("请输入有效的手机号码"));
            }
          }
          callback();
        }
      };
      var validatePass = (rule, value, callback) => {
        if (/^[0-9a-zA-Z]{8,}$/.test(value) && isNaN(value)) {
          if (this.details.checkPass !== "") {
            this.$refs.details.validateField("checkPass");
          }
          callback();
        } else {
          callback(new Error("必须是8位以上字母和数字组合"));
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === "") {
          callback(new Error("请再次输入密码"));
        } else if (value !== this.details.password) {
          callback(new Error("两次输入密码不一致!"));
        } else {
          callback();
        }
      };
      return {
        show: true,
        times: "",
        timer: null,
        details: {
          userName: "",
          imageVerification: "",
          telCode: "",
          password: "",
          checkPass: "",
          typeId: this.$store.state.typeId,
        },
        rules: {
          userName: [{validator: validateMobilePhone, trigger: "blur"}],
          password: [{validator: validatePass, trigger: "blur"}],
          checkPass: [{validator: validatePass2, trigger: "blur"}],
        },
        dialogVisible: false,
        imgcode: "/portal/reader/imageVerification",
      };
    },
    methods: {
      signbtn(row) {
        register({
          checkPass: row.checkPass,
          userName: row.userName,
          typeId: this.typeId,
          password: this.$md5(row.password),
          telCode: row.telCode,
          typeId: this.$store.state.typeId,
        }).then((res) => {
          if (res && res.data.code === 200) {
            if (row.password != row.checkPass) {
              return
            } else {
              this.$alert("注册成功", "提示", {
                confirmButtonText: "确定",
                callback: (action) => {
                  this.dialogVisible = false;
                  this.details = {};
                },
              });

            }
          } else {
            this.$message({
              message: res.data.message,
              type: 'error'
            })
          }
        });
      },
      changeimgcode() {
        var num = Math.ceil(Math.random() * 10);
        this.imgcode = "/portal/reader/imageVerification?" + num;
      },
      getcode(row) {
        telVerification({
          tel: row.userName,
          imageVerification: row.imageVerification,
        }).then((res) => {
          if (res.data.code === 200) {
            const TIME_TIMES = 60;
            if (!this.timer) {
              this.times = TIME_TIMES;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.times > 0 && this.times <= TIME_TIMES) {
                  this.times--;
                } else {
                  this.show = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          } else {
            this.$alert(res.data.message);
          }
        });
      },
      loginBtn() {
        this.dialogVisible = false;
      },
      openDialog() {
        this.dialogVisible = true;
        this.loginForm = Object.assign({});
      },
    },
  };
</script>

<style lang="less" scoped>
  .Sign {
    .sign-menu {
      padding: 0 20px;

      .el-button {
        width: 24.75rem;
        background-color: #9d2236;
        border-radius: 6px;
        color: #fff;
        font-size: 16px;
        letter-spacing: 2px;
      }

      .verify {
        width: 7.621rem;
        height: 2.643rem;
        font-size: 12px;
        margin: 0;
        position: relative;
        letter-spacing: 1px;
        // left: 12px;
        left: 1.125rem;
      }

      .imageVerification {
        // width: 7.5rem;
        height: 2.604rem;
        position: relative;
        top: 0px;
      }
    }

    .login-text {
      font-size: 16px;
      letter-spacing: -1px;
      padding-top: 4px;
      text-align: center;

      span {
        color: #9d2236;
        cursor: pointer;
      }
    }

    .left-img {
      width: 27.083rem;
      height: 35.25rem;
      background: url("../../../assets/image/login/login_bg.png");
      position: absolute;
      top: 0;
      left: -27.083rem;
    }

    /deep/ .el-dialog__header {
      height: 4.74rem;
      text-align: center;
      // padding: 40px 20px 10px;
    }

    /deep/ .el-dialog__title {
      color: #333;
      font-size: 1.771rem;
    }
  }

  /deep/ .el-dialog__headerbtn {
    right: 34px;
  }

  /deep/ .el-input--small .el-input__inner {
    // width: 25.75rem;
    height: 2.604rem;
    border-radius: 6px;
    font-size: 1rem;
  }

  /deep/ .el-input__inner:focus {
    border-color: #ccc;
  }

  /deep/ .el-dialog {
    width: 27.083rem;
    height: 35.25rem;
    border-radius: 0 0.521rem 0.521rem 0;
    margin-left: 50%;
  }

  /deep/ .el-icon-close:before {
    color: #9d2236;
  }

  /deep/ .el-dialog__wrapper {
    background: url("../../../assets/image/index/index_bg.png") no-repeat;
    background-size: 100% 100%;

  }

  /deep/ .el-dialog__body {
    padding: 0;
  }

  /deep/ .el-icon-close:before {
    color: #9d2236;
    content: '返回上一页';
  }

</style>
